import * as types from "../types";

export default {
  [types.GET_TEAM_SELECT](state, data) {
    state.teamList = data;
  },
  [types.GET_CUSTOMDETAIL](state, data) {
    state.customDetail = data;
  },
  [types.GET_CUSTOM_LIST](state, data) {
    state.customList = data;
  },
  [types.GET_MEDICAL_CUSTOM_LIST](state, data) {
    state.medicalCustomList = data;
  },
  [types.GET_PROJECT_LIST](state, data) {
    state.projectList = data;
  },
  [types.GET_CUSTOM_APPLY_LIST](state, data) {
    state.customerApplyList = data;
  },
  [types.GET_CUSTOM_CONTACTS](state, data) {
    state.customContacts = data;
  },
  [types.GET_CUSTOM_VISITS](state, data) {
    state.customVisits = data;
  },
  [types.GET_CUSTOM_BUSI](state, data) {
    state.customBusi = data;
  },
  [types.GET_CUSTOM_COMPACT](state, data) {
    state.customCompact = data;
  },
  [types.GET_CUSTOM_HOSPITAL_LEVEL](state, data) {
    state.hospitalLevel = data.results;
  },
  [types.GET_CUSTOM_FOLLOW_UP](state, data) {
    state.customerFollowUp = data.results;
  },
  [types.GET_DOCTOR_LIST](state, data) {
    state.doctorList = data;
  },
  [types.GET_OPERATOR_LIST](state, data) {
    state.operators = data;
  },
  [types.GET_CUSTOM_ARCHIVE_LIST](state, data) {
    state.customArchiveData = data;
  },
  [types.GET_DOCTOR_ARCHIVE_LIST](state, data) {
    state.doctorListData = data;
  },

  [types.GET_CUSTOM_SALESMAN](state, data) {
    state.customSalesman = data;
  },
  [types.GET_FINALLY_CUSTOM](state, data) {
    state.finallyCustomData = data;
  },
  [types.GET_REFUSED_CUSTOMER](state, data) {
    state.refusedCustomData = data;
  },
  [types.GET_GOVERNMENT_DATA](state, data) {
    state.governmentData = data;
  },
  [types.GET_GOVERNMENT_BUSILINE](state, data) {
    state.busiLine = data;
  },
  [types.GET_INVESTIGATION_PERSON](state, data) {
    state.investigationPerson = data;
  },
  [types.GET_GOVERNMENT_DETAIL](state, data) {
    state.governmentDetail = data;
  },
  [types.GET_PROJECT_DATA](state, data) {
    state.projectData = data.data;
  },
  [types.GET_PROFOLLOW_DATA](state, data) {
    state.proFollowData = data;
  },
  [types.GET_CUSTOM_PROJECT](state, data) {
    state.projectDetailList = data;
  },
  [types.GET_CUSTOMER_HOLD](state, data) {
    state.customerHoldBoolean = data.data;
  },
  [types.GET_CUSTOM_TYPE_NO_DOC](state, data) {
    state.customType = data;
  },
};
